import React, { useState, useEffect, useMemo } from 'react';
import {
  CardAvatar,
  CardHeader,
  VerticalSpace,
} from '@brokerbay/design-components';
import { MailFilled } from '@ant-design/icons';

import { MailerController, SecretsController } from 'api';
import { message } from 'components';
import { SALES_EMAIL } from 'utils/constants';
import type { IContactSalesFormBody } from '@/app-package';
import { OnboardingContactSalesForm } from '../../../components';
import EmailSentView from '../../common/EmailSentView';
import errorReporter from '../../../../../app/errorReporter';

export type FindBrokerageViewProps = { handleGoBackStep: () => void };

const ContactSalesView = (props: FindBrokerageViewProps) => {
  const { handleGoBackStep } = props;

  const [working, setWorking] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [authUrl, setAuthUrl] = useState('');
  useEffect(() => {
    const fetchAuthUrl = async () => {
      try {
        const data = await SecretsController.getAuthUrl();
        setAuthUrl(data.authUrl);
      } catch (err) {
        errorReporter.error(err);
        setAuthUrl('https://auth.brokerbay.com'); // Set default
      }
    };

    fetchAuthUrl();
  }, []);

  const loginUrl = useMemo(() => {
    if (!authUrl) return undefined;

    const [subdomain] = window.location.hostname.split('.');
    const redirect = `${authUrl}?client=${subdomain}`;

    return redirect;
  }, [authUrl]);

  const contactSales = async (values: IContactSalesFormBody) => {
    if (working) return;
    setWorking(true);

    try {
      await MailerController.contactSalesForm(values);
      setSubmitted(true);
    } catch (err) {
      message.error(
        `Could not submit form. Please try again or contact us directly at ${SALES_EMAIL}`,
      );
    } finally {
      setWorking(false);
    }
  };

  if (submitted) {
    return <EmailSentView loginUrl={loginUrl} />;
  }

  return (
    <VerticalSpace>
      <CardHeader
        title="Contact our sales team"
        icon={<CardAvatar icon={MailFilled} />}
        onRequestStepBack={handleGoBackStep}
      />
      <OnboardingContactSalesForm
        reason={null} // Null reason signifies org onboarding contact form
        onSubmit={contactSales}
        working={working}
      />
    </VerticalSpace>
  );
};

export default ContactSalesView;
